import { ArrowLeft, Play, Search, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { videos } from "./helpCenterData";
import styles from "../HelpCenter.module.css";
import vidStyles from "./HelpVideosPage.module.css";
import Footer from "../../../ui/Footer/Footer";
const HelpVideosPage = () => {
  const [search, setSearch] = useState("");
  const filtered = search
    ? videos.filter(
        (v) =>
          v.title.toLowerCase().includes(search.toLowerCase()) ||
          v.description.toLowerCase().includes(search.toLowerCase()),
      )
    : videos;

  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <div className={styles.heroInner}>
          <div className={styles.heroNav}>
            <Link to="/HelpCenter" className={styles.backLink}>
              <ArrowLeft size={16} /> Back to Help Center
            </Link>
          </div>
          <h1 className={styles.heroTitle}>Video Tutorials</h1>
          <p className={styles.heroSubtitle}>
            Learn viewStruct through step-by-step video guides.
          </p>
          <div className={styles.searchBox}>
            <Search size={18} className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Search videos..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className={styles.tabBar}>
        <Link to="/contact" className={styles.tab}>
          Contact Us
        </Link>
        <Link to="/HelpCenter" className={`${styles.tab} ${styles.tabActive}`}>
          Help Center
        </Link>
        {/* <Link to="/issues" className={styles.tab}>
          Report an Issue
        </Link> */}
      </div>

      <div className={styles.mainContent}>
        <div className={vidStyles.grid}>
          {filtered.map((video) => (
            <div key={video.id} className={vidStyles.card}>
              <div className={vidStyles.thumb}>
                <div className={vidStyles.playBtn}>
                  <Play size={24} />
                </div>
              </div>
              <div className={vidStyles.info}>
                <h3>{video.title}</h3>
                <p>{video.description}</p>
                <span className={vidStyles.duration}>
                  <Clock size={14} /> {video.duration}
                </span>
              </div>
            </div>
          ))}
        </div>
        {filtered.length === 0 && (
          <div className={vidStyles.noResults}>
            No videos found matching your search.
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default HelpVideosPage;
